import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import house from '../../assets/images/footer/house.png'
import tour from '../../assets/images/footer/location-dot.png'
import member from '../../assets/images/footer/user-group.png'
import spot from '../../assets/images/footer/camera.png'
import mypage from '../../assets/images/footer/circle-user.png'

class Footer extends React.Component {
  render () {
    return (
      <React.Fragment>
        <footer>
          <div className="container">
            <div className="footer-contents">
              <a href="/touring_groups">
                <div>
                  <img src={house} alt="home" />
                  <p>Home</p>
                </div>
              </a>
              <a href="/touring_groups/touring_group_new_all">
                <div>
                  <img src={tour} alt="tour" />
                  <p>Tour</p>
                </div>
              </a>
              <a href="/users/search"> 
                <div>
                  <img src={member} alt="member" />
                  <p>Member</p>
                </div>
              </a>
              <a href="/spot_maps">
                <div>
                  <img src={spot} alt="spot" />
                  <p>Spot</p>
                </div>
              </a>
              <a href={`/users/${this.props.currentUserId}`}>
                <div>
                  <img src={mypage} alt="Mypage" />
                  <p>My Page</p>
                </div>
              </a>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

Footer.propTypes = {
  currentUserId: PropTypes.number,
};

export default Footer
